@for (option of renderedOptions(); track $index) {
  <label [ngClass]="{ 'radio--inline': inline() }" appFormControl class="radio">
    <input
      (blur)="onBlur()"
      (focus)="onFocus()"
      [attr.required]="required"
      [formControl]="control"
      [name]="nameInput() ?? name"
      [value]="option.value"
      class="radio__input radio__input--{{ size() }}"
      type="radio"
    />

    <span class="radio__label"> {{ option.label }}</span>
  </label>
}
